import { FC, useEffect, useRef } from 'react';

interface Event {
    id: number;
    title: string;
    date: string;
    description: string;
    latitude: number;
    longitude: number;
}

interface MapViewProps {
    events: Event[];
    onEventClick: (event: Event) => void;
}

const MapView: FC<MapViewProps> = ({ events, onEventClick }) => {
    // Reference to store the map instance and markers
    const mapRef = useRef<google.maps.Map | null>(null);
    const markersRef = useRef<google.maps.Marker[]>([]);

    useEffect(() => {
        if (!mapRef.current) {
            // Initialize the map once
            initMap();
        } else {
            // If the map is already initialized, just update markers
            updateMarkers();
        }
    }, [events]);

    // Initialize the map once
    function initMap() {
        const defaultLat = 37.7749;
        const defaultLng = -122.4194;
        mapRef.current = new google.maps.Map(document.getElementById("map") as HTMLElement, {
            center: { lat: defaultLat, lng: defaultLng },
            zoom: 5,
            draggable : true
        });

        updateMarkers();
    }

    // Update markers based on events
    function updateMarkers() {
        // Clear existing markers
        markersRef.current.forEach(marker => marker.setMap(null));
        markersRef.current = [];

        // Filter valid events
        const validEvents = events.filter(e => {
            const latitude = parseFloat(e.latitude.toString());
            const longitude = parseFloat(e.longitude.toString());
            return !isNaN(latitude) && !isNaN(longitude);
        });

        if (validEvents.length === 0) return;

        // Add new markers
        validEvents.forEach((event) => {
            const marker = new google.maps.Marker({
                position: { lat: parseFloat(event.latitude.toString()), lng: parseFloat(event.longitude.toString()) },
                map: mapRef.current, // Use the existing map
                draggable: false,
            });
            console.log(validEvents)

            marker.addListener("click", () => onEventClick(event));

            // Store the marker for later removal
            console.log(`Marker added: ${markersRef.current.length} markers`);

            markersRef.current.push(marker);
        });
    }

    return (
        <div className="fsdpe-calendar-wrapper__map">
            <div id="map" className={'fsdpe-map-wrapper'} style={{ width: "100%", paddingBottom: "60%" }}></div>
        </div>
    );
};

export default MapView;
